import { SITE_URL } from "/constants/API_constants.js";

export function switchToSearchPreviewWindow(searchInput) {
    let searchLine = searchInput.value;
    searchLine = searchLine.replaceAll('+', '%2B');
    searchLine = searchLine.replaceAll(' ', '+');

    window.location = SITE_URL + '/search/preview=' + searchLine;
}

export function switchToSearchNodesWindow(searchInput, page) {
    let searchLine = searchInput.value;
    searchLine = searchLine.replaceAll('+', '%2B');
    searchLine = searchLine.replaceAll(' ', '+');

    window.location = SITE_URL + '/search/branches=' + searchLine + '/page=' + page;
}